import React from "react";
import PropTypes from "prop-types";

import { Icon } from "@lululemon/ui-library";
import { plusIcon16, minusIcon16 } from "@lululemon/ui-icons";

import { formatTruncatedButtonTracking } from "@lululemon/ecom-common/src/lib/analytics";

import styles from "./view-more-button.module.scss";

export const ViewMoreButton = React.memo(
  ({
    toggleExpandedItems,
    isTrucatedFilterExpanded,
    panelName,
    primaryNumRefinements,
    facetLength,
  }) => {
    const buttonName = `View ${isTrucatedFilterExpanded ? "Less" : "More"}`;
    const position = isTrucatedFilterExpanded
      ? facetLength + 1
      : primaryNumRefinements + 1;
    return (
      <button
        data-testid="filter-view-more"
        onClick={() => toggleExpandedItems(panelName)}
        type="button"
        className={styles.viewMoreWrapper}
        {...formatTruncatedButtonTracking(buttonName, position, panelName)}
      >
        <span className={styles.viewMoreTitle}>{buttonName}</span>
        <Icon content={isTrucatedFilterExpanded ? minusIcon16 : plusIcon16} />
      </button>
    );
  }
);

ViewMoreButton.displayName = "ViewMoreButton";

ViewMoreButton.propTypes = {
  facetLength: PropTypes.number,
  isTrucatedFilterExpanded: PropTypes.bool.isRequired,
  panelName: PropTypes.string.isRequired,
  primaryNumRefinements: PropTypes.number.isRequired,
  toggleExpandedItems: PropTypes.func.isRequired,
};

ViewMoreButton.defaultProps = {
  facetLength: 0,
};

export default ViewMoreButton;
